import React from "react";

export const ExternalLinkIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_812_11708)">
      <path
        d="M16.6667 16.6667H7.33333V7.33333H11.1429V6H7.33333C6.59333 6 6 6.6 6 7.33333V16.6667C6 17.4 6.59333 18 7.33333 18H16.6667C17.4 18 18 17.4 18 16.6667V12.8571H16.6667V16.6667ZM13.3333 6V7.33333H15.7267L9.17333 13.8867L10.1133 14.8267L16.6667 8.27333V10.6667H18V6H13.3333Z"
        fill="#88A3AB"
      />
    </g>
    <defs>
      <clipPath id="clip0_812_11708">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
